@if (loading) {
  <div class="section panel-loading">
    <motn-spinner></motn-spinner>
  </div>
} @else {

  <!-- Devices section -->
  <div class="section border-bottom">
    <div class="section-label">Devices</div>
    <div class="facet-wrap" cdkOverlayOrigin #deviceOrigin="cdkOverlayOrigin">
      <div class="input-field-wrap" #deviceTrigger (click)="toggleDeviceOpen()">
        <span [class.placeholder]="!selectedDeviceIds.length">
          {{ deviceTriggerLabel || 'Select devices' }}
        </span>
        @if (selectedDeviceIds.length) {
          <button type="button" class="clear-btn" (click)="clearDevices($event)">
            <i class="fa-regular fa-circle-xmark"></i>
          </button>
        }
        <i class="fa-regular fa-chevron-down"></i>
      </div>
      @if (openKey === 'devices') {
        <motn-popover-multi-select
          [externalOrigin]="deviceOrigin"
          [triggerEl]="deviceTrigger"
          [optionGroup]="deviceOptionGroup"
          [multiOrSingle]="'multi'"
          [loading]="loadingDevices"
          [autoFocusSearch]="true"
          [overlayPositions]="facetOverlayPositions"
          (clickedOutsideMenu$)="openKey = null"
          (clickedOption$)="onDeviceToggled($event)"
        ></motn-popover-multi-select>
      }
    </div>
    @if (selectedDeviceIds.length) {
      <div class="device-pills">
        @for (id of selectedDeviceIds; track id) {
          <motn-pill [removable]="true" (remove)="removeDevice(id)">{{ getDeviceName(id) }}</motn-pill>
        }
      </div>
    }
  </div>

  <!-- Facet sections -->
  @if (facetTags.length) {
    <div class="section border-bottom">
      @for (facet of facetTags; track facet.ID) {
        <div class="facet-group">
          <div class="section-label">{{ formatTagLabel(facet.Label) }}</div>
          <div class="facet-wrap" cdkOverlayOrigin #facetOrigin="cdkOverlayOrigin">
            <div class="input-field-wrap" #facetTrigger (click)="toggleFacetOpen(facet.ID)">
              <span [class.placeholder]="!facetValues[facet.ID]">
                {{ facetValues[facet.ID] || 'Select' }}
              </span>
              @if (facetValues[facet.ID]) {
                <button type="button" class="clear-btn" (click)="clearFacet(facet.ID, $event)">
                  <i class="fa-regular fa-circle-xmark"></i>
                </button>
              }
              <i class="fa-regular fa-chevron-down"></i>
            </div>
            @if (openKey === facet.ID) {
              <motn-popover-multi-select
                [externalOrigin]="facetOrigin"
                [triggerEl]="facetTrigger"
                [optionGroup]="getFacetOptionGroup(facet)"
                [multiOrSingle]="'single'"
                [autoFocusSearch]="false"
                [overlayPositions]="facetOverlayPositions"
                (clickedOutsideMenu$)="openKey = null"
                (clickedOption$)="onFacetSelected(facet.ID, $event)"
              ></motn-popover-multi-select>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Tags section -->
  <div class="section">
    <div class="section-label">Tags</div>
    <app-tag-input
      [objectType]="ObjectType.TILE"
      [existingTags]="tagFilterApplied"
      [compact]="true"
      [createLabel]="null"
      (tagsChanged)="onTagsChanged($event)"
    ></app-tag-input>
  </div>

}
